import { apiLoyaltyProgramParticipantUserService } from '@api/services/user/loyaltyProgram/loyaltyProgramParticipantUser.apiService';
import { IApiLoyaltyProgramParticipantUserInfo } from '@api/services/user/loyaltyProgram/loyaltyProgramParticipantUser.apiService.interface';
import { getUserStatusData } from '@components-member/userDataProvider';
import { NUMBER_OF_ROWS } from '@components-shared/table/constants';
import { keyMap } from '@locales/lokalise/keyMap';
import { handleError } from '@utils/errors';
import { makeAutoObservable, runInAction } from 'mobx';
import { MobxRootStore } from './mobx.store';

export class LoyaltyProgramStore {
  mobxStore: MobxRootStore;

  private _loyaltyProgramInfo: IApiLoyaltyProgramParticipantUserInfo[] = [];

  constructor(mobxStore: MobxRootStore) {
    this.mobxStore = mobxStore;
    makeAutoObservable(this);
  }

  fetchLoyaltyProgramInfo = async () => {
    const { LoyaltyPrograms } = this.mobxStore.featuresStore.featureFlags;
    const { onboardingConfiguration, userInfo } = this.mobxStore.accountStore;
    const { isUserApproved } = getUserStatusData(userInfo);

    if (!LoyaltyPrograms || !onboardingConfiguration?.showLoyaltyProgramsTab || !isUserApproved) {
      return;
    }

    try {
      const response = await apiLoyaltyProgramParticipantUserService.getInfo(0, NUMBER_OF_ROWS[2]);

      runInAction(() => {
        this._loyaltyProgramInfo = response.data;
      });
    } catch (error) {
      handleError(keyMap.sharedErrorsFailedToGetRecord, error);
    }
  };

  get LoyaltyProgramInfo() {
    return this._loyaltyProgramInfo;
  }
}
